import React from "react";
import { withTranslation } from "react-i18next";
import "./scheduler-calendar.scss";
import Calendar from "react-calendar";
import moment from "moment";

function SchedulerCalendar({
  t,
  value,
  onChange,
  onActiveStartDateChange,
  onClickDay,
  className,
  tileClassName,
  onTodayClick,
  activeStartDate,
  minDate,
  maxDate,
  minDetail,
  tileDisabled,
  showNeighboringMonth,
  dateFormat,
  formatShortWeekday,
  selected,
  tileContent,
  showTodayButton,
}) {
  return (
    <>
      {showTodayButton && (
        <p
          className={"today_text"}
          onClick={() => {
            if (onTodayClick) {
              onTodayClick();
            } else {
              onChange(new Date());
            }
          }}
          style={{ cursor: "pointer" }}
        >
          {t("today")}
        </p>
      )}
      <Calendar
        onChange={onChange}
        value={value}
        tileClassName={tileClassName}
        onClickDay={onClickDay}
        className={className || "scheduler-calendar"}
        formatMonth={(locale, date) => moment(date).format("MMM")}
        formatMonthYear={(locale, date) => moment(date).format("MMM YYYY")}
        onActiveStartDateChange={onActiveStartDateChange}
        activeStartDate={activeStartDate}
        minDate={minDate}
        tileDisabled={tileDisabled}
        maxDate={maxDate}
        dateFormat={dateFormat}
        selected={selected}
        minDetail={minDetail}
        showNeighboringMonth={showNeighboringMonth}
        formatShortWeekday={formatShortWeekday}
        tileContent={tileContent}
      />
    </>
  );
}

export default withTranslation()(SchedulerCalendar);
